const prefix = '/hospital/specialist/';
const route = [
  {
    path: `${prefix}:category/home`, // mother -> 母婴，andrology -> 专科，fatloss -> 减脂
    name: 'SpecialistHome',
    component: () => import(/* webpackPrefetchPlaceHolder */ './index'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '众安互联网医院',
  },
  {
    path: `${prefix}pregnancyTest`,
    name: 'pregnancyTest',
    component: () => import(/* webpackPrefetchPlaceHolder */ './pregnancyTest'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '孕期测试',
  },
  {
    path: `${prefix}pregnancyTest/:type`,
    name: 'pregnancyTestEntry',
    component: () => import('./pregnancyTest/entry'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '众安互联网医院',
  },
  {
    path: `${prefix}pregnancyTest/:type/question`,
    name: 'pregnancyTestEntry',
    component: () => import('./pregnancyTest/question'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '众安互联网医院',
  },{
    path: `${prefix}pregnancyTest/:type/result`,
    name: 'testResult',
    component: () => import('./pregnancyTest/result'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '孕期测试',
  },
  {
    path: `${prefix}archives`,
    name: 'SpecialistArchives',
    component: () => import(/* webpackPrefetchPlaceHolder */ './archives'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '孕妈档案',
  },
  {
    path: `${prefix}expected`,
    name: 'SpecialistExpected',
    component: () => import(/* webpackPrefetchPlaceHolder */ './expected'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '孕妈预产期',
  },
  {
    path: `${prefix}inspection`,
    name: 'SpecialistInspection',
    component: () => import(/* webpackPrefetchPlaceHolder */ './inspection'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '产检时间表',
  },
  {
    path: `${prefix}:category/choose`,
    name: 'SpecialistChoose',
    component: () => import(/* webpackPrefetchPlaceHolder */ './choose'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '选择医生',
  },
  {
    path: `${prefix}:category/textInquiry`,
    name: 'SpecialistText',
    component: () => import(/* webpackPrefetchPlaceHolder */ './textInquiry'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '名医图文问诊',
  },
  {
    path: `${prefix}:category/videoInquiry`,
    name: 'SpecialistText',
    component: () => import(/* webpackPrefetchPlaceHolder */ './videoInquiry'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '专家视频问诊',
  },
  {
    path: `${prefix}booking/:status`,
    name: 'SpecialistText',
    component: () => import(/* webpackPrefetchPlaceHolder */ './booking'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '专家视频问诊',
  },
];

export default route;
